export enum RewardsStatus {
  Pending,
  Claimed,
  Expired
}
